//package import 
import React, { useEffect, useState } from "react";

//component import 
import { ShareValueDetials } from "../../services/apiServices/GetServices";
import { callShareValueEdit } from "../../services/apiServices/PostServices";
import ShareValueEdit from "../../utils/resuableComponents/ShareValueEdit";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { showToast } from "../../utils/constants/Toaster";
import Loader from "../loadingScreens/Loader";



const PriceConfiguration = () => {

    const [shareValueDetails, setShareValueDetails] = useState([])
    const [rangeOneFromVal,setRangeOneFromVal]=useState(0)
    const [rangeOneToVal,setRangeToVal]=useState(0)
    const [rangeTwoFromVal,setRangeTwoFromVal]=useState(0)
    const [rangeTwoToVal,setRangeTwoToVal]=useState(0)
    const [rangeOneCostVal,setRangeOneCostVal]=useState(0)
    const [rangeTwoCostVal,setRangeTwoCostVal]=useState(0)
    const [modalData,setModalData]=useState([])
    const [shareModalOpen,setShareModalOpen]=useState(false)
    const [priceEditAlert,setPriceEditAlert]=useState(false)
    const [reqbody,setReqbody]=useState({})
    const [modalBlur, setModalBlur] = useState(false)
    const [isLoader,setIsLoader]=useState(false)

    useEffect(() => {
        callShareDetailsApi()
    }, [])

    //function to call share value details
    const callShareDetailsApi = async () => {
        setIsLoader(true)
        try{
            const res = await ShareValueDetials("osanShares")
            if (res?.success) {
                setShareValueDetails(res?.osanShares)
                setRangeOneFromVal(res?.osanShares[0]?.from_)
                setRangeToVal(res?.osanShares[0]?.to_)
                setRangeOneCostVal(res?.osanShares[0]?.value)
                setRangeTwoFromVal(res?.osanShares[1]?.from_)
                setRangeTwoToVal(res?.osanShares[1]?.to_)
                setRangeTwoCostVal(res?.osanShares[1]?.value)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
        
    }
    
    //function to convert value into string conversion
    const formatNumber = (value) =>  {
        if (value >= 10000000) {
          return (value / 10000000).toFixed(0) + 'Cr';
        } else if (value >= 100000) {
          return (value / 100000).toFixed(0) + 'L';
        } else {
          return value.toString();
        }
      }

    //function call to edit share value
    const handleEditShareValue = (data) => {
        setModalData(data)
        setShareModalOpen(true)
        setModalBlur(false)
    }

    //function call to close modal
    const handleCloseShareModal = () => {
        setShareModalOpen(false)
    }

    //function call to open edit share modal
    const handleOnclickEdit = (reqbody) => {
      setReqbody(reqbody)
      setPriceEditAlert(true)
      setModalBlur(true)
    } 

    //function call to close request modal
    const handleAlertClose = () => {
        setPriceEditAlert(false)
        setModalBlur(false)
    }

    //function call to handle edit api
    const handledShareEditApi = async () => {
        try{
            const res =await callShareValueEdit('shareValue',reqbody)
            if(res?.success){
             showToast(1,res?.message)
             setPriceEditAlert(false)
             setShareModalOpen(false)
             callShareDetailsApi()
            }else{
             console.log("res",res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    return (
        <div class="col-lg-12 d-flex  flex-column">
            {isLoader ? <Loader/> : null}
            <div class="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 class="fs-4 mx-3 ps-1 Montserrat fw-semi-bold">
                    Share Value
                </h1>
            </div>

            <div class="  col-lg-12 d-flex  flex-row justify-content-center align-items-center">
                <div class="d-flex col-lg-6  border-end flex-column">
                    <div >
                    <div class="container  d-flex flex-row justify-content-around mt-4">
                        <div class="col-lg-7 d-flex flex-column text-center boxBackgroundStyle border border-primary rounded py-5">
                            <h3 class="colorPrimary"><b>From {rangeOneFromVal} - {formatNumber(rangeOneToVal)} </b></h3>
                            <h3 class="colorPrimary"><b>Value : ₹{rangeOneCostVal}</b></h3>
                        </div>
                    </div>
                    </div> 
                    <div>
                    </div>
                </div>

                <div class="d-flex col-lg-6   flex-column">
                    <div>
                    <div class="container d-flex flex-row justify-content-around mt-4">
                        <div class="col-lg-7 d-flex flex-column text-center boxBackgroundStyle border border-primary rounded py-5">
                        <h3 class="colorPrimary"><b>From {formatNumber(rangeTwoFromVal)} - {formatNumber(rangeTwoToVal)} </b></h3>
                            <h3 class="colorPrimary"><b>Value : ₹{rangeTwoCostVal}</b></h3>
                        </div>
                    </div>
                    </div>
                </div>

            </div>
            <div class="d-flex col-lg-11 my-2 justify-content-start mx-4 my-4" >
                <div class="col-lg-12  border rounded mt-3" >
                    <div class="d-flex justify-content-between col-lg-10 mx-2 ">
                    <h2 class=" fw-bold ps-1 mb-3 fs-4 Montserrat">Share Range</h2>
                    <h2 class=" fw-bold ps-1 mb-3 fs-4 Montserrat me-5">Share Price</h2>
                    </div>
                    <div class="mx-2">
                    {
                                shareValueDetails.map((data,index) => {

                             return (
                                <div class="d-flex" key={index}>
                                <div class="d-flex w-100 flex-column"> 
                                <h5 class="paraColor m-0 " >Shares from</h5>
                               <p class="w-75 border fs-6 h-75 p-2 rounded" >{data?.from_}</p>
                                </div>   
                                <div class="d-flex w-100 flex-column"> 
                                <h5 class="paraColor m-0 " >Shares to</h5>
                               <p class="w-75 border  fs-6 h-75 p-2 rounded" >{data?.to_}</p>
                                </div>    
                                <div class="d-flex w-100 flex-column"> 
                                <h5 class="paraColor m-0" >Shares Value</h5>
                               <p class="w-75 border fs-6 h-75 p-2 rounded" >{data?.value} Rs</p>
                                </div>
                                <div class="thin-border" onClick={() => handleEditShareValue(data)}>
                                <i class="bi bi-pencil-fill" style={{marginLeft:"5px" }}  ></i> 
                                    </div>
                                </div>
                             )       
                                })
                            }                       
                    </div>    
                </div>
                 
            </div>
            <ShareValueEdit open={shareModalOpen} close={handleCloseShareModal} data={modalData} onClickAction={handleOnclickEdit} blur={modalBlur} />
            <CustomModal
                        close={handleAlertClose}
                        open={priceEditAlert}
                        modalContent={"This change may impact the current users who have purchased the shares. Do you still wish to proceed?"}
                        Action={handledShareEditApi}
                    />
        </div>
    )
}

export default PriceConfiguration